import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import translationEN from './locales/en/translation.json';
import translationES from './locales/es/translation.json';
import moment from "moment";
import 'moment/locale/es';

moment.locale(navigator?.language || navigator?.userLanguage || 'en');

// the translations
const resources = {
  en: {
    translation: translationEN
  },
  es: {
    translation: translationES
  }
};

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources,
    lng: "es",
    fallbackLng: "es",
    keySeparator: false,

    interpolation: {
      escapeValue: false
    }
  });

export default i18n;